import React from "react";
import ReactDOM from "react-dom";

import App from "./App.js";

import "./index.css";

import CacheBuster from "CacheBuster.js";

ReactDOM.render(
  <React.StrictMode>
    <CacheBuster>
      <App />
    </CacheBuster>
  </React.StrictMode>,
  document.getElementById("root")
);
